import React, { useState, useEffect } from 'react'
import { Act_Header, Act_Body, Navbar, Footer } from '../container'
import { Helmet } from "react-helmet";

const ActividadRBS = () => {
    
  
    return (
      <div className='App'>
        <Navbar />
        <Act_Header />
        <Footer />
      </div>
    )
  }
  
  export default ActividadRBS
  